import LanguageSwitcher from './LanguageSwitcher';

function Header() {
  return (
    <header className="site-header">
      <LanguageSwitcher />
    </header>
  );
}

export default Header;
